import type { MediaType } from "@/lib/media";

export const regionOptions = ["全部地区", "中国大陆", "中国香港", "中国台湾", "美国", "日本", "韩国", "英国"];

export const yearOptions = ["全部年份", "2025", "2024", "2023"];

export const ratingOptions = [
  { label: "全部评分", value: 0 },
  { label: "8 分以上", value: 8 },
  { label: "8.5 分以上", value: 8.5 },
  { label: "9 分以上", value: 9 },
];

export const genresByType = ["全部类型", "剧情", "悬疑", "犯罪", "科幻", "爱情", "喜剧", "奇幻", "冒险", "治愈", "古装", "真人秀"];

export const genreByCategory: Record<MediaType, string[]> = {
  movie: ["全部类型", "剧情", "悬疑", "犯罪", "科幻", "爱情", "青春", "冒险", "家庭", "史诗"],
  tv: ["全部类型", "悬疑", "犯罪", "剧情", "都市", "古装", "科幻", "医疗", "家庭", "职场"],
  variety: ["全部类型", "音乐", "真人秀", "喜剧", "户外", "旅行", "竞技", "纪实", "人文"],
  anime: ["全部类型", "奇幻", "科幻", "冒险", "国风", "治愈", "热血", "武侠", "机战", "日常"],
};